<script>
export default {
  name: "ConfirmLeave",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<template>
  <div
    class="confirmation confirmation--centered confirmation--large"
    :class="{ active: isOpen }"
  >
    <div class="confirmation__overlay" @click="$emit('cancel')" />
    <div class="confirmation__box d-flex flex-column justify-content-center">
      <div class="confirmation__box__text">
        {{ $t('CONFIRM_IMPORT_LEAVE') }}
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-center"
      >
        <button class="btn btn-outline-primary btn-xl mr-3" @click="$emit('cancel')">
          {{ $t("CONTINUE_WITH_IMPORT") }}
        </button>
        <button
          class="btn btn-primary btn-xl d-flex align-items-center justify-content-center"
          @click="$emit('confirm')"
        >
          {{ $t("CREATE_DATA_FLOW") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>